module.exports = __webpack_public_path__ + "img/good-detail.f5bf6d38.jpg";